export default __webpack_public_path__ + "static/privacy-32637eb7fbc721d305f18762aaa1ed3b.png";